#version 300 es

layout(location = 0) in vec4 aPosition;
layout(location = 1) in vec2 aTexCoord;

out vec2 vTexCoord;

void main() {
  vTexCoord = vec2(aTexCoord.s, 1.0f - aTexCoord.t);
  gl_Position = aPosition;
}